import React, { useEffect, useState } from 'react';
import { useTranslate } from 'react-polyglot';
import Field from '../../../Shared/Wizard/Field/Field';
import {components} from 'react-select';

import { FormGroup } from 'react-bootstrap';
import { Grid, Tooltip, Switch } from '@material-ui/core';

import moment from 'moment';
import { useAuth } from '../../../../Auth';

function EventResourceGuests(props) {
    const auth = useAuth();
    const t = useTranslate();
    
    const [doubleBookingChecked, setDoubleBookingChecked] = useState(false);
    
    function getPriceAndUnit(resource, selectedDeal) {
        let output = {unit: "", price: ""};

        function getPriceByUnit(priceList, unit) {
            if (unit == "") {
                return priceList[0].price;
            } else {
                return priceList.find(p => p.unit == unit)?.price ?? priceList[0].price;
            }
        }

        let exactPrices: Array<any> = [];
        let subcatPrices: Array<any> = [];
        let catPrices: Array<any> = [];

        if (selectedDeal != undefined ){
            exactPrices = selectedDeal["priceList"].filter(i => i.resource == resource.resource);
            subcatPrices = selectedDeal["priceList"].filter(i => i.resourceType == resource.resourceType && i.resourceSubtype == resource.resourceSubtype && i.resource == "");
            catPrices = selectedDeal["priceList"].filter(i => i.resourceType == resource.resourceType && i.resourceSubtype == "");
        }

        if (exactPrices.length > 0) {
                output.price = getPriceByUnit(exactPrices, resource.unit);
                output.unit = exactPrices[0].unit;
        } else if (subcatPrices.length > 0) {
                output.price = getPriceByUnit(subcatPrices, resource.unit);
                output.unit = subcatPrices[0].unit;
        } else if (catPrices.length > 0) {
                output.price = getPriceByUnit(catPrices, resource.unit);
                output.unit = catPrices[0].unit;
        } else {
            let defaultDeal = props.allDeals.find(item => item.isDefaultDeal != false);

            let exactPricesDefaultDeal = defaultDeal["priceList"].filter(i => i.resource == resource.resource);
            let subcatPricesDefaultDeal = defaultDeal["priceList"].filter(i => i.resourceType == resource.resourceType && i.resourceSubtype == resource.resourceSubtype && i.resource == "");
            let catPricesDefaultDeal = defaultDeal["priceList"].filter(i => i.resourceType == resource.resourceType && i.resourceSubtype == "");
            
            if (exactPricesDefaultDeal.length > 0) {
                output.price = getPriceByUnit(exactPricesDefaultDeal, resource.unit);
                output.unit = exactPricesDefaultDeal[0].unit;
            } else if (subcatPricesDefaultDeal.length > 0) {
                output.price = getPriceByUnit(subcatPricesDefaultDeal, resource.unit);
                output.unit = subcatPricesDefaultDeal[0].unit;
            } else if (catPricesDefaultDeal.length > 0) {
                output.price = getPriceByUnit(catPricesDefaultDeal, resource.unit);
                output.unit = catPricesDefaultDeal[0].unit;
            }
        }

        return output;
    }

    function getAddedGuest(resource, resourceBooking: any = undefined) {
        let people: Array<any> = [];
        if (resourceBooking == undefined) {
            if (resource.bookings != undefined) {
                resource.bookings.forEach(booking => {
                    if(booking.eventId != null && booking.eventId != undefined && booking.eventId != ""){
                        if(booking.eventId.map(id => id).includes(props.event._id)){
                            if (booking.people != undefined) {
                                booking.people.forEach(person => {
                                    let foundPerson = props.guests.find(p => p._id == person);
                                    if (foundPerson != undefined && !people.map(i => i._id).includes(person)) {
                                        people.push(foundPerson);
                                    }
                                });
                            }
                        }
                    }
                });
            }
        } else {
            if(resourceBooking.eventId != null && resourceBooking.eventId != undefined && resourceBooking.eventId != ""){
                if(resourceBooking.eventId.map(id => id).includes(props.event._id)){
                    if (resourceBooking.people != undefined) {
                        resourceBooking.people.forEach(person => {
                            let foundPerson = props.guests.find(p => p._id == person);
                            if (foundPerson != undefined && !people.map(i => i._id).includes(person)) {
                                people.push(foundPerson);
                            }
                        });
                    }
                }
            }
        }

        return people;
    }

    function getAllGuests() {
        if (props.guests != undefined && props.guests.length != 0 && props.resourcesInEvent != undefined) {
            let allPeople = props.guests;

            return allPeople.map(person => {
                let personBooking = props.allBookings?.find(b => b.guests?.map(i => i._id).includes(person._id) ?? undefined) ?? undefined;
                let bookingPerson = personBooking?.guests?.find(p => p._id == person._id) ?? {};
                return {
                    ...person,
                    info: bookingPerson?.note ?? "",
                };
            });
        } else {
            return [];
        }
    }

    function getAllGuestsFromBooking(bookingId) {
        let currentBooking = props.allBookings.find(b => b._id == bookingId);
        if(props.guests != undefined && currentBooking != undefined){
            if (currentBooking.guests != undefined && props.guests.length != 0 && currentBooking.resources != undefined) {
                let allPeople = props.guests.filter(p => currentBooking.guests.map(i => i._id).includes(p._id));

                return allPeople;
            } else {
                return [];
            }
        }
        
    }

    function getNonAddedGuest() {
        if (props.guests != undefined && props.guests.length != 0 && props.resourcesInEvent != undefined) {
            let allPeople = props.guests;
            let bookedPeople: Array<any> = [];
            
            props.resourcesInEvent.forEach(resource => {
                let resourcePeople = getAddedGuest(resource);
                resourcePeople.forEach(resourcePerson => {
                    bookedPeople.push(resourcePerson);
                });
            });

            return allPeople.filter(person => !bookedPeople.map(i => i._id).includes(person._id)).map(person => {
                let personBooking = props.allBookings?.find(b => b.guests?.map(i => i._id).includes(person._id) ?? undefined) ?? undefined;
                let bookingPerson = personBooking?.guests?.find(p => p._id == person._id) ?? {};
                return {
                    ...person,
                    info: bookingPerson?.note ?? "",
                };
            });
        } else {
            return [];
        }
    }

    function getNonAddedGuestFromBooking(bookingId) {
        let currentBooking = props.allBookings.find(b => b._id == bookingId);
        if(props.guests != undefined && currentBooking != undefined){
            if (currentBooking.guests != undefined && props.guests.length != 0 && currentBooking.resources != undefined) {
                let allPeople = props.guests.filter(p => currentBooking.guests.map(i => i._id).includes(p._id));
                let bookedPeople: Array<any> = [];
                
                props.resourcesInEvent.forEach(resource => {
                    let resourcePeople = getAddedGuest(resource);
                    resourcePeople.forEach(resourcePerson => {
                        bookedPeople.push(resourcePerson);
                    });
                });

                return allPeople.filter(person => !bookedPeople.map(i => i._id).includes(person._id));
            } else {
                return [];
            }
        }
        
    }

    function updateResource(resource, val, bookingId, booking) {
        if(props.event._id != null){
            let tempResources = props.allResources;
            let index = tempResources.map(i => i._id).indexOf(resource._id);
            tempResources = tempResources.filter(r => r._id != resource._id);

            let tempBookings = resource.bookings;
            let tempBooking = tempBookings.find(b => b.bookingId == bookingId);
            tempBookings = tempBookings.filter(b => b.bookingId != bookingId);

            let people = tempBooking?.people ?? undefined;
            let eventId = tempBooking?.eventId ?? [props.event._id];

            if (tempBooking != undefined) {
                if (people == undefined) { people = [] };
                if(val.length <= 0){
                    tempBooking.bookingId = "";
                    tempBooking.state = "reserved";
                    tempBooking.bookingtimes = tempBooking.bookingtimes.map(time => {return {...time, state: "reserved", people: []}});
                }
                people = val.map(p => p.value);
                tempBooking.people = people;
                tempBooking.eventId = eventId;
                tempBookings.push(tempBooking);
            } else {
                let reservedBooking = tempBookings.find(b => b.uuid == booking.uuid);
                tempBookings = tempBookings.filter(b => b.uuid != booking.uuid);
                reservedBooking.bookingId = bookingId;
                reservedBooking.people = val.map(p => p.value);
                reservedBooking.eventId = eventId;
                reservedBooking.state = "exists";

                tempBookings.push(reservedBooking);
            }
            
            resource.bookings = tempBookings;
            tempResources.splice(index, 0, resource);

            if (props.onResourcesChange != undefined) {
                props.onResourcesChange(JSON.parse(JSON.stringify(tempResources)));
            }
            
            localStorage.setItem("editedItems", "true");
        }
    }

    function updateBooking(resource, val, bookingId, booking){
        let tempBookings = props.allBookings;
        let tempBooking = props.allBookings.find(b => b._id == bookingId);
        let tempBookingResource:any = {};
        if(tempBooking == undefined){
            if(booking.eventId == undefined){
                return undefined;
            }
            let bookingsWithResource = tempBookings.filter(booking => booking.resources.some(r => r.resource == resource._id.toString()));
            bookingsWithResource = bookingsWithResource.filter(booking => booking.events?.some(evt => evt._id.toString() == props.event._id));
            
            let bookingsIds = bookingsWithResource.map(booking => booking._id);
            tempBookings = tempBookings.filter(booking => !bookingsIds.includes(booking._id));
            bookingsWithResource.forEach(booking => {

                booking.resources = booking.resources.filter(r => r.resource != resource._id);
                tempBookings.push(booking);
            });       
        }
        if(val.length <= 0 && tempBooking != undefined){
            tempBooking.resources = tempBooking.resources.filter(res => res.resourceType != resource.resourceType || res.resourceSubtype != resource.resourceSubtype || res.resource != resource._id);
            tempBookings = [...tempBookings.filter(b=> b._id != bookingId), tempBooking];
        } else {
            
            if(tempBooking != undefined) { 

                tempBookingResource = {
                    resourceType: resource.resourceType,
                    resourceSubtype: resource.resourceSubtype,
                    resource: resource._id,
                    unit: "day",
                    price: 0
                }

                let prices = getPriceAndUnit(resource, tempBooking.deal);
                tempBookingResource.price = prices.price;
                tempBookingResource.unit = prices.unit;

            }

            if(tempBooking != undefined) {
                tempBooking.resources.push(tempBookingResource);
                tempBookings = [...tempBookings.filter(b=> b._id != bookingId), tempBooking];
            }
        }
        
        if (props.onBookingsChange != undefined) {
            props.onBookingsChange(JSON.parse(JSON.stringify(tempBookings)));
        }
    }

    useEffect(() => {
        
    }, [props.allBookings]);

    useEffect(() => {
        props.resourcesInEvent.sort((a,b) => (a.name > b.name) ? 1 : (b.name > a.name) ? -1 : 0)
    }, [props.resourcesInEvent]);

    function getBookingName(booking) {
        let properBooking = props.allBookings.find(b => b._id == booking["bookingId"]);
        if (properBooking == undefined) return "";
        let customer = props.allCustomers.find(c => c._id == properBooking.customerId);
        if (customer == undefined) return "Finner ikke customer";

        return properBooking.bookingnumber + " - " + customer.organizationName;
    }

    const CustomOption = props => {
        let newChildren = <div>
            {props.data.data.organization != "" ?
                <p style={{ marginBottom: "0px", fontSize: "11px"}}>{props.data.data.organization}</p>
            : null}
            {props.data.data.email != "" || props.data.data.phone != "" ?
                <p style={{ marginBottom: "0px", fontSize: "11px"}}>{props.data.data.email + (props.data.data.email != "" && props.data.data.phone != "" ? " | " : "") + props.data.data.phone}</p>
            : null}
            {props.children}
            <hr style={{margin: "0px"}} />
        </div>;
        return (
            <div>
                <components.Option {...props} children={newChildren} />
            </div>
        );
    }
  
    return (
        <div style={{ marginTop: '30px'}}>
            <h3>{t("event.resourceGuests.title")}</h3>
            <p>{t("booking.resourceguests.description")}</p>
            {auth.user["userdata"]["orgRole"][0] != "janitor" ?
                <div className="riskMatrixToggle" style={{height: "40px"}}>
                    <FormGroup style={{width: "max-content"}}>
                        <Tooltip
                            title= {t("booking.doubletoggle_showtooltip")}
                            placement="right"
                        >
                            <Grid component="label" container alignItems="center" spacing={1} style={{float: "right"}}>
                                <Grid item>
                                    <Switch
                                        size="small"
                                        checked={doubleBookingChecked}
                                        onChange={ evt => setDoubleBookingChecked(!doubleBookingChecked)}
                                        className={"toggleswitch"}
                                        color="primary"
                                    />
                                </Grid>
                                <Grid item>{t("booking.guests.doublebooking")}</Grid>
                            </Grid>
                        </Tooltip>
                    </FormGroup>
                </div>
            : null }
            <table className="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th>{t("event.resourceGuests.tabletitle.resource")}</th>
                        <th>{t("event.resourceGuests.tabletitle.organization")}</th>
                        <th>{t("event.resourceGuests.tabletitle.persons")}</th>
                    </tr>
                </thead>
                <tbody>
                    {props.resourcesInEvent != undefined ?
                        props.resourcesInEvent.map((resource,key1) => { 
                            return resource.bookings.map((booking, key2) => {
                                if (booking.eventId != [] && booking.eventId != undefined && props.event._id != undefined && booking.eventId.includes(props.event._id.toString())) {
                                    return <tr key={key1 + "-" + key2}>
                                        <td>{resource.name}</td>
                                        <td>{props.allBookings.length > 0 ? getBookingName(booking) : ""}</td>
                                        <td style={{padding: "0px 8px", minWidth: "200px"}}>
                                            {auth.user["userdata"]["orgRole"][0] == "janitor" ?
                                                <>
                                                    <table style={{
                                                        width: "100%",
                                                    }}>
                                                        <tbody>
                                                            {getAddedGuest(resource, booking).map((guest, guestkey) => 
                                                                <tr key={guestkey} style={{
                                                                    backgroundColor: "transparent",
                                                                }}>
                                                                    <td style={{
                                                                        padding: "4px 10px",
                                                                        border: "none",
                                                                    }}>{guest.lastname}, {guest.firstname}</td>
                                                                    <td style={{
                                                                        padding: "4px 10px",
                                                                        border: "none",
                                                                    }}>
                                                                        <p style={{
                                                                            margin: "0px",
                                                                        }}>{
                                                                            booking.bookingtimes.filter(t => t.people?.includes(guest._id) ?? false).map(time => {
                                                                                let start = moment(time.start);
                                                                                let end = moment(time.end);
                                                                                let diffYear = false;
                                                                                if (start.get('year') != end.get('year')) {
                                                                                    diffYear = true;
                                                                                }
                                                                                return diffYear ? start.format("DD.MM.yyyy") + " -> " + end.format("DD.MM.yyyy") : start.format("DD.MM") + " -> " + end.format("DD.MM")
                                                                            }).join(", ")
                                                                        }</p>
                                                                    </td>
                                                                    <td style={{
                                                                        padding: "4px 10px",
                                                                        border: "none",
                                                                        width: "120px",
                                                                        textAlign: "right",
                                                                    }}>{guest.phone}</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </>
                                            :
                                                <>
                                                    <Field
                                                        type="selectmulti"
                                                        value={getAddedGuest(resource, booking).map(guest => { return {label: guest.lastname + ", " + guest.firstname, value: guest._id} })}
                                                        options={{
                                                            choices: props.guests != undefined ?
                                                                !doubleBookingChecked ?
                                                                    booking.bookingId != "" && booking.bookingId != undefined ?
                                                                        getNonAddedGuestFromBooking(booking.bookingId)?.map(guest => {return {
                                                                            label: guest.lastname + ", " + guest.firstname,
                                                                            value: guest._id,
                                                                            data: guest
                                                                        }})
                                                                    :
                                                                        getNonAddedGuest().map(guest => {return {
                                                                            label: guest.lastname + ", " + guest.firstname,
                                                                            value: guest._id,
                                                                            data: guest
                                                                        }})
                                                                :
                                                                    booking.bookingId != "" && booking.bookingId != undefined ?
                                                                        getAllGuestsFromBooking(booking.bookingId)?.map(guest => {return {
                                                                            label: guest.lastname + ", " + guest.firstname,
                                                                            value: guest._id,
                                                                            data: guest
                                                                        }})
                                                                    :
                                                                        getAllGuests().map(guest => {return {
                                                                            label: guest.lastname + ", " + guest.firstname,
                                                                            value: guest._id,
                                                                            data: guest
                                                                        }})
                                                            : [],
                                                            //filterOption: (opt, val) => true,
                                                            //isOptionSelected: (opt, val) => false,
                                                            choosetext: t("booking.resourceguests.choosegueststext"),
                                                            customOption: CustomOption
                                                        }}
                                                        onChange={(val) => {
                                                            let bookingsInEvent = props.allBookings.filter(booking => booking.events != undefined ? booking.events.map(event => event._id).includes(props.event._id) : false);
                                                            let actualBooking = bookingsInEvent.filter(booking => booking.guests?.map(guest => guest._id).includes(val[0]?.value));

                                                            if(booking.bookingId != ""){
                                                                updateResource(resource, val, booking.bookingId, booking);
                                                            } else if(actualBooking[0] != undefined){
                                                                updateResource(resource, val, actualBooking[0]._id, booking);
                                                                updateBooking(resource, val, actualBooking[0]._id, booking);
                                                            } 
                                                            if(val.length == 0){
                                                                updateBooking(resource, val, booking.bookingId, booking);
                                                            }
                                                        }}
                                                    ></Field>
                                                    {getAddedGuest(resource, booking).map((guest, guestkey) => {
                                                        return <div key={guestkey} className="row">
                                                            <div className="col col-sm-6" style={{
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                flexFlow: "column",
                                                                paddingBottom: "18px",
                                                                textAlign: "right"
                                                            }}>
                                                                <p style={{
                                                                    height: "22px",
                                                                    marginBottom: "0px"
                                                                }}>{guest.lastname}, {guest.firstname}</p>
                                                            </div>
                                                            <div className="col col-sm-6 nobottommargin">
                                                                <Field
                                                                    type="selectmulti"
                                                                    value={
                                                                        booking.bookingtimes.filter(t => t.people?.includes(guest._id) ?? false).map(time => {
                                                                            let start = moment(time.start);
                                                                            let end = moment(time.end);
                                                                            let diffYear = false;
                                                                            if (start.get('year') != end.get('year')) {
                                                                                diffYear = true;
                                                                            }
                                                                            return {
                                                                                label: diffYear ? start.format("DD.MM.yyyy") + " -> " + end.format("DD.MM.yyyy") : start.format("DD.MM") + " - " + end.format("DD.MM"),
                                                                                value: time.uuid
                                                                            }
                                                                        })
                                                                    }
                                                                    options={{
                                                                        choosetext: t("booking.resourceguests.chooseperiodstext"),
                                                                        choices: booking.bookingtimes.map(time => {
                                                                            let start = moment(time.start);
                                                                            let end = moment(time.end);
                                                                            let diffYear = false;
                                                                            if (start.get('year') != end.get('year')) {
                                                                                diffYear = true;
                                                                            }
                                                                            return {
                                                                                label: diffYear ? start.format("DD.MM.yyyy") + " -> " + end.format("DD.MM.yyyy") : start.format("DD.MM") + " - " + end.format("DD.MM"),
                                                                                value: time.uuid
                                                                            }
                                                                        })
                                                                    }}
                                                                    onChange={(val) => {
                                                                        for (let time of booking.bookingtimes) {
                                                                            if (val.map(v => v.value).includes(time.uuid)) {
                                                                                if (time.people == undefined) {
                                                                                    time.people = [guest._id];
                                                                                } else {
                                                                                    if (!time.people.includes(guest._id)) {
                                                                                        time.people.push(guest._id);
                                                                                    }
                                                                                }
                                                                            } else {
                                                                                if (time.people != undefined) {
                                                                                    if (time.people.includes(guest._id)) {
                                                                                        time.people.splice(time.people.indexOf(guest._id), 1);
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }}
                                                                ></Field>
                                                            </div>
                                                        </div>
                                                    })}
                                                </>
                                            }
                                        </td>
                                    </tr>
                                }
                            })
                        })
                    : null}
                </tbody>
            </table>
            <div>
                <h4>{t("event.resourceGuests.guestList.title")}</h4>
                <table style={{ width: "100%" }} className="table table-striped table-sm">
                    <thead>
                        <tr>
                            <th>{t("event.resourceGuests.guestList.table.name")}</th>
                            <th>{t("event.resourceGuests.guestList.table.organisation")}</th>
                            <th>{t("event.resourceGuests.guestList.table.notes")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {getNonAddedGuest().map((guest, key) => 
                            <tr key={key}>
                                <td style={{ padding: "2px" }}>{guest.firstname + " " + guest.lastname}</td>
                                <td style={{ padding: "2px" }}>{guest.organization}</td>
                                <td style={{ padding: "2px" }} dangerouslySetInnerHTML={{__html: guest.info}}></td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default EventResourceGuests;